<template>
    <div>
        <!-- Modal Composição -->
        <div class="modal fade" id="composicaoKitModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Composição</h5>
                        <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!dados" msg="Composição não identificada." />

                        <template v-else>

                            <div id="impressao-composicao">
                                <cabecalho-generico titulo="Composição" />

                                <div class="alert alert-info d-flex justify-content-between">
                                    <div>
                                        {{ dados.item.search }}
                                        <div class="small" v-if="dados.st_observacao">
                                            {{ dados.st_observacao }}
                                        </div>
                                    </div>
                                    <div class="text-right">
                                        {{ dados.st_lote }}
                                        <div class="small">
                                            x{{ dados.in_quantidade }}
                                        </div>
                                    </div>
                                </div>

                                <div class="alert alert-secondary d-flex justify-content-between" v-if="dados.item.saldo_por_lote && dados.item.saldo_por_lote.length">
                                    <div>Saldo</div>
                                    <div>{{ dados.item.saldo_por_lote.length ? dados.item.saldo_por_lote[0].qtd : 0 }}
                                        <a href="#" @click.prevent="desmontar(dados)" class="card-link d-print-none ml-2" title="Desmontar" v-if="dados.item.saldo_por_lote[0].qtd > 0">
                                            <i class="fa-solid fa-box-open"></i>
                                        </a>
                                    </div>
                                </div>

                                <div class="card mb-3" v-if="dados.lista_mov && dados.lista_mov.length">
                                    <div class="card-header">
                                        Movimentações
                                    </div>
                                    <table class="table table-sm mb-0">
                                        <thead>
                                            <tr>
                                                <th>Id</th>
                                                <th>Data</th>
                                                <th>Tipo</th>
                                                <th>Responsável</th>
                                                <th class="text-right">Qtd</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item_mov, imx) in dados.lista_mov" :key="imx">
                                                <td>
                                                    #{{ item_mov.id_estoque_movimentacao }}
                                                </td>
                                                <td>
                                                    {{ $util.getFormatDate(item_mov.dt_movimentacao) }}
                                                    {{ item_mov.dt_movimentacao.slice(11,16) }}
                                                </td>
                                                <td>
                                                    {{ item_mov.tipo.search }}
                                                </td>
                                                <td>
                                                    {{ item_mov.usuario.st_login }}
                                                </td>
                                                <td class="text-right">
                                                    {{ item_mov.in_quantidade }}
                                                    <i class="fa fa-plus-circle text-success ml-2" aria-hidden="true" v-if="item_mov.tipo.fl_entrada"></i>
                                                    <i class="fa fa-minus-circle text-danger ml-2" aria-hidden="true" v-else></i>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        Composição
                                    </div>
                                    <table class="table table-sm mb-0">
                                        <thead>
                                            <tr>
                                                <th>Id</th>
                                                <th>Descrição</th>
                                                <th>Lote</th>
                                                <th>Qtd</th>
                                                <th>Obs</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(link, icx) in dados.links" :key="icx">
                                                <td>#{{ link.model.item.id_estoque_item }}</td>
                                                <td>{{ link.model.item.search }}</td>
                                                <td>{{ link.model.st_lote }}</td>
                                                <td>{{ link.model.in_quantidade }}</td>
                                                <td>{{ link.model.st_observacao }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        
                            <button type="button" class="btn btn-outline-primary" title="Imprimir" @click="imprimir()">
                                <i class="fa fa-print" aria-hidden="true"></i>
                            </button>

                        </template>

                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzEmptyState from '../../util/AzEmptyState.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';

export default {
    data() {
        return { 
            dados: null, 
        }
    },

    components: { 
        AzEmptyState, 
        CabecalhoGenerico, 
    },

    methods: { 
        fechar_modal () { 
            $('#composicaoKitModal').modal('hide');
        },

        imprimir () { 
            this.$htmlToPaper('impressao-composicao', null);
        },

        desmontar () { 
            if ( !confirm('Confirma desmontar o item, voltando o saldo para os itens compostos?') ) 
                return;

            this.$util.atualizar(this, { 
                service: 'estoque', 
                func: 'desmontar',
                dados: { 
                    id: this.dados.item.id_estoque_item,
                    id_mov: this.dados.id_estoque_movimentacao,
                },
                modal: 'composicaoKitModal',
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

        abrir (mov, rebusca = false) { 
            this.dados = null;

            $('#composicaoKitModal').modal('show');

            this.$util.load(this, { 
                service: "estoque_movimentacoes",
                func: 'show',
                parms: { 
                    id: mov.id_estoque_movimentacao,
                    composicao: true, 
                },
                loadTo: res => { 
                    this.dados = res;

                    if ( !rebusca && res.lista_mov && res.lista_mov.length ) { 
                        if ( mov.id_estoque_movimentacao != res.lista_mov[0].id_estoque_movimentacao ) { 
                            this.abrir(res.lista_mov[0], true);    
                        }
                    }
                }
            });
        }
    }
}
</script>
